if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }
      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${event.detail.currentElement.dataset.mediaId}"]`);
        this.setActiveThumbnail(thumbnail);
      }
      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) || this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) return;
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => element.classList.remove('is-active'));
        activeMedia?.classList?.add('is-active');
        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }
        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        });
        this.playActiveMedia(activeMedia);
        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;
        this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }
      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => this.elements.liveRegion.setAttribute('aria-hidden', true), 2000);
        };
        image.src = image.src;
      }
      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }
      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }
      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

/* Colorify: speed-only variant image preloading for STARMIST/MUBAH */
(function () {
  if (window.__colorifyFastVariantImages) return;
  window.__colorifyFastVariantImages = true;

  function init() {
    var picker = document.querySelector('variant-selects');
    var title = picker && picker.dataset.productTitle || document.title || '';
    if (!/STARMIST|MUBAH/i.test(title)) return;

    var handle = picker && picker.dataset.productHandle;
    if (!handle) {
      var m = location.pathname.match(/\/products\/([^/?#]+)/);
      handle = m && m[1];
    }
    if (!handle) return;

    var productPromise = fetch(
      (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'products/' + handle + '.js',
      { credentials: 'same-origin', cache: 'force-cache' }
    ).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });

    productPromise.then(function (product) {
      if (!product || !product.variants) return;
      product.variants.forEach(function (variant) {
        var src = variant.featured_image && variant.featured_image.src;
        if (src) {
          var img = new Image();
          img.decoding = 'async';
          img.src = src;
        }
      });
    });

    function selectedVariant(product) {
      var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      var id = idInput && idInput.value;
      if (id) {
        var byId = product.variants.find(function (v) { return String(v.id) === String(id); });
        if (byId) return byId;
      }
      var values = picker ? Array.from(picker.querySelectorAll('select option[selected], fieldset input:checked')).map(function (el) { return el.value; }) : [];
      if (!values.length) return null;
      return product.variants.find(function (v) {
        return v.options && v.options.length === values.length && v.options.every(function (value, i) { return String(value) === String(values[i]); });
      }) || null;
    }

    function apply(variant) {
      var src = variant && variant.featured_image && variant.featured_image.src;
      if (!src) return;
      var gallery = document.querySelector('media-gallery');
      var img = gallery && gallery.querySelector('.product__media-item.is-active img, .product__media img');
      if (!img) return;
      var clean = src.split('?')[0];
      if ((img.currentSrc || img.src || '').split('?')[0] === clean) return;
      img.style.transition = 'opacity .04s linear';
      img.style.opacity = '1';
      img.src = src;
      img.srcset = src + ' 1x';
    }

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !(target.closest('variant-selects') || target.matches('input[name="id"]') || target.closest('variant-radios'))) return;
      productPromise.then(function (product) {
        if (product) apply(selectedVariant(product));
      });
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
